import { RESET_PASSWORD } from "../../constants/reset-password.constants";

const initialState = {
  loading: false,
  data: false,
  error: '',
};

export function resetPassword(state = initialState, action: any) {
  switch (action.type) {
    case RESET_PASSWORD.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        data: false,
        error: '',
      };
    case RESET_PASSWORD.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        data: true,
        loading: false,
        error: '',
      };
    case RESET_PASSWORD.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        loading: false,
        data: false,
        error: action.error,
      };
    case RESET_PASSWORD.RESET_PASSWORD_CLEAR:
      return {
        ...state,
        loading: false,
        data: false,
        error: '',
      };
    default:
      return state;
  }
}
